import axiosInstance from "./axios.config";

export async function getLeagueParticipants(league_id) {
  try {
    const response = await axiosInstance.get(
      `/leagues/${league_id}/participants`
    );
    console.log("response get participants == ", response.data);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}

export async function getLeagueSeasons(league_id) {
  try {
    const response = await axiosInstance.get(`seasons?league_id=${league_id}`);

    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}

export async function getJoinedLeague() {
  try {
    const response = await axiosInstance.get(`leagues/joined-leagues`);

    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}

export async function getInviteLink(league_id) {
  try {
    const response = await axiosInstance.get(`leagues/${league_id}/invite`);

    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}

export async function getLeagueDetail(league_id) {
  try {
    const response = await axiosInstance.get(`leagues/${league_id}`);

    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}

export async function acceptInvitation(league_id, token) {
  try {
    const response = await axiosInstance.post(`leagues/${league_id}/accept`, {
      invite_token: token,
    });

    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}

export async function getLeagueThemes() {
  try {
    const response = await axiosInstance.get(`/leagues/themes`);
    console.log("response get themes ==  getLeagueThemes", response);
    return response?.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}

export async function getLeagueAcceptanceStatus(league_id) {
  try {
    const response = await axiosInstance.get(
      `/leagues/${league_id}/acceptance`
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}

export async function updateLeague(league_id, data) {
  try {
    const response = await axiosInstance.put(`leagues/${league_id}`, data);

    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}
